import { Routes } from '@angular/router';
import { appRouteConstants } from './app.route.constants';
import { LoginComponent } from './components/authentication/login/login.component';
import { AuthenticationGuard } from './components/authentication/guard/authentication.guard';
import { ResetPasswordReqComponent } from './components/authentication/reset-request/reset-password-request.component';
import { ResetPasswordComponent } from './components/authentication/reset/reset.-password.component';



export const routes: Routes = [
    {
        path: appRouteConstants.AUTH.LOGIN,
        component: LoginComponent,
        pathMatch: 'full'
    },

    {
        path: appRouteConstants.AUTH.RESET_REQUEST,
        component: ResetPasswordReqComponent,
        pathMatch: 'full'
    },

    {
        path: appRouteConstants.AUTH.RESET,
        component: ResetPasswordComponent,
        pathMatch: 'full'
    },

    {
        path: 'employee',
        canActivate: [AuthenticationGuard],
        loadChildren: () =>
            import('./components/main-component.module').then(m => m.MainComponentModule)
    },
    {
        path: '',
        redirectTo: appRouteConstants.AUTH.LOGIN,
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: appRouteConstants.AUTH.LOGIN
    }
];
